
import { Component, Vue } from 'vue-property-decorator'

import UserList from '@/components/UserList.vue'
import UserHelp from '@/components/UserHelp.vue'

@Component({ components: { UserList, UserHelp } })
export default class Users extends Vue {}
